import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faAt } from "@fortawesome/free-solid-svg-icons"

export const At = (props) => {
  return <FontAwesomeIcon faIcon={faAt} {...props} />
}
